module.exports = __webpack_public_path__ + "static/media/Menu-dimsum-BG2.9564ba8d.jpg";